module.exports = __webpack_public_path__ + "static/media/step-3.a005b25f.jpg";